module.exports = __webpack_public_path__ + "img/cb9-r-001.916ce589.gif";